import { render, staticRenderFns } from "./default-opt-in-form.vue?vue&type=template&id=2de60a5c&scoped=true&"
import script from "./default-opt-in-form.vue?vue&type=script&lang=js&"
export * from "./default-opt-in-form.vue?vue&type=script&lang=js&"
import style0 from "./default-opt-in-form.vue?vue&type=style&index=0&id=2de60a5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de60a5c",
  null
  
)

export default component.exports